import React from "react"

function Header(){
    return (
        <header>
            <img src="/logo2.jpg" alt="logo" />
        </header>
    )
}

export default Header;